import BaseComponent from "../../base/base_component";
import DateFormatter from "../../utils/date_formatter";
import Directive from "../../core/directive";
import {GermanyResponsibleGamingButtonPlacement} from "../../../../common/const/responsible-gaming";
import SessionTimerController from "../session_timer/session_timer_controller";
import {SYSTEM_EVENTS, USER_EVENTS} from "../../events/events";
import Event from "../../utils/event";
import Device from '../../utils/device/device';

const DETAILS_VIEW = require('./view/details.html');
const ANALYTICS_CATEGORY = 'Client_GamingHistory_Detailed';


const DOM_OBJECTS_IDS = {
    DETAILS_HISTORY: '.cgp-details-history',
    DETAILS_HEADER_NAME: '.cgp-header-game-name',
    DETAILS_HEADER_DATETIME: '.cgp-header-game-datetime',
    DETAILS_CONTAINER: '.cgp-details-history-game-container',
    AGE_RESPONSIBLE_GAME: '.cgp-details-history-age-responsible-game',
    RESPONSIBLE_GAME_ICONS: '.cgp-details-history-resp-game-icons',
    DETAILS_HEADER_SESSION_TIME: '.cgp-details-session-time',
    DETAILS_HEADER_CLOSE: '.cgp-themes-icons-x'
}


export class DetailHistoryComponentController extends BaseComponent {

    _gameBodyComponent = null;
    _analyticsLabel = null;
    init(params) {
        params.innerHtml = DETAILS_VIEW;
        super.init(params);
        const {historyRecordData, gameType, gameName, gameBodyComponent, gameBackgroundImageUrl, gameInfo} = params;
        this._gameBodyComponent = gameBodyComponent;
        this._gameInfo = gameInfo;
        this._analyticsLabel = this._getAnalyticsLabel(gameType, gameName);
        const container = this.getEl();

        if (!Device.os.isMobileOS && gameBackgroundImageUrl) {
            container.querySelector(DOM_OBJECTS_IDS.DETAILS_HISTORY).style.backgroundImage = 'url(' + gameBackgroundImageUrl + ')';
        }

        container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_NAME).innerHTML = gameName;
        let historyDate = this.serviceFactory.clockService().formatToRegulationOffset(historyRecordData.Date, historyRecordData.DateInTimeZone);
        container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_DATETIME).innerHTML = DateFormatter.format(historyDate.date.toString(), this.serviceFactory.skinService().getDateTimeHistoryFormat(), historyDate.isUTC);

        this.appendChildComponent(gameBodyComponent, DOM_OBJECTS_IDS.DETAILS_CONTAINER);

        this._injectAgeResponsibleGame(container);
        this._injectResponsibleGameIcons(container);
        this._injectSessionTimer(container);

        this._analyticsBind(container);

        // Bind Close Button
        this.onDOMEvent(container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_CLOSE), USER_EVENTS.ON_CLICK, () => {
            //The reason we do it like this is because also Orbit wants to close the detail history window when the route changes (user press the back button in the browser)
            //and we want to share the close logic between SDK and Orbit
            this.serviceFactory.gameService().closeCurrentDetailHistory();
        });

    }

    _injectAgeResponsibleGame(container) {
        if (!this.serviceFactory.regulationService().getRegulation().showAgeResponsibleGameInDetailedHistory()) {
            return;
        }

        let ageResponsibleGame = Directive.generate({directiveName: 'age_responsible_game', start: true, props: {}});
        container.querySelector(DOM_OBJECTS_IDS.AGE_RESPONSIBLE_GAME).appendChild(ageResponsibleGame.getEl())
    }

    _injectResponsibleGameIcons(container) {
        if (!this.serviceFactory.regulationService().getRegulation().showResponsibleIcons()) {
            return;
        }

        let responsibleIcons = Directive.generate({directiveName: 'responsible_gaming_icons', start: true, props: {placement:GermanyResponsibleGamingButtonPlacement.inDetailedHistory}});
        //DOM.addClass(responsibleIcons.getEl(), 'cgp-theme-property-background-color-dark-grey');
        container.querySelector(DOM_OBJECTS_IDS.RESPONSIBLE_GAME_ICONS).appendChild(responsibleIcons.getEl())
    }

    _injectSessionTimer(container) {
        if (!this.serviceFactory.regulationService().sessionTimerVisible()) {
            return;
        }

        let sessionTimer = SessionTimerController.create();
        sessionTimer.start();
        this.innerComponentsRef.push(sessionTimer);
        container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_SESSION_TIME).appendChild(sessionTimer.getEl());
    }

    _analyticsBind(container) {
        const label = this._analyticsLabel;
        // Bind Close Overlay
        this.onDOMEvent(container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_CLOSE), USER_EVENTS.ON_CLICK, () => {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: ANALYTICS_CATEGORY,
                action: 'CloseClick',
                label: label
            });
        });


        // Bind click header elements
        this.onDOMEvent(container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_NAME), USER_EVENTS.ON_CLICK, () => {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: ANALYTICS_CATEGORY,
                action: 'GameName',
                label: label
            });
        });

        this.onDOMEvent(container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_DATETIME), USER_EVENTS.ON_CLICK, () => {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: ANALYTICS_CATEGORY,
                action: 'Time',
                label: label
            });
        });
    }

    _getAnalyticsLabel(gameType, gameName) {
        if (!gameName) {
            return gameType;
        }

        return gameType + '_' + gameName.replace(/ /g, '');
    }

    _closeDetails() {
        this.shutDown();
        window.CGP.closeLastOverlay();
    }

    showHistoryDetails() {
        const analytics_label = this._analyticsLabel;

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'Client_GamingHistory',
            action: 'MoreDetails',
            label: analytics_label
        });

        window.CGP.openOverlay({
            el: this.getEl(),
            level: 2,
            isCloseBtnAllowed: false,
            additionalClasses: ['cgp-overlay-history-details'],
            closeCallback: () => {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                    category: ANALYTICS_CATEGORY,
                    action: 'Close',
                    label: analytics_label
                });
            },
            openCallback: () => {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                    category: ANALYTICS_CATEGORY,
                    action: 'Open',
                    label: analytics_label
                });
            }
        });

        this.serviceFactory.gameService().attachDetailHistoryCloseHandler(this._closeDetails.bind(this));

        this._gameBodyComponent.onAppendedToDOM();

    }

}